import { useTranslation } from 'react-i18next'
import { TemplateUpdateParams } from '../../../../types'
import { UseFormReturn } from 'react-hook-form'
import VariableTextInput from '../../../../ui/form/VariableTextInput'
import JsonField from '../../../../ui/form/JsonField'
import { SingleSelect } from '../../../../ui/form/SingleSelect'
import Accordion from '../../../../ui/Accordion'

const textOptions = [
    ['badge', 'push_badge'],
    ['sound', 'push_sound'],
    ['category', 'push_category'],
    ['collapse_key', 'push_collapse_key'],
    ['thread_id', 'push_thread'],
] as const

const androidOptions = [
    ['android_channel_id', 'push_android_channel'],
    ['tag', 'push_tag'],
] as const

export const PushForm = ({ form }: { form: UseFormReturn<TemplateUpdateParams, any> }) => {
    const { t } = useTranslation()
    const optionField = ([field, label]: readonly [string, string]) => (
        <VariableTextInput.Field
            key={field}
            form={form}
            name={`data.${field}`}
            label={t(label)}
            subtitle={t(`${label}_desc`)} />
    )
    return <>
        <VariableTextInput.Field
            form={form}
            name="data.title"
            label={t('title')}
            required />
        <VariableTextInput.Field
            form={form}
            name="data.body"
            label={t('body')}
            multiline
            required />
        <VariableTextInput.Field
            form={form}
            name="data.url"
            label={t('deeplink')} />
        <JsonField
            form={form}
            name="data.custom"
            label={t('raw_json')}
            textarea />
        <Accordion items={[{
            title: <strong>{t('push_delivery_options')}</strong>,
            content: <>
                {textOptions.map(optionField)}
                <SingleSelect.Field
                    form={form}
                    name="data.priority"
                    label={t('push_priority')}
                    subtitle={t('push_priority_desc')}
                    options={[
                        { key: 'high', label: t('push_priority_high') },
                        { key: 'normal', label: t('push_priority_normal') },
                    ]}
                    toValue={o => o.key}
                    getOptionDisplay={o => o.label} />
                {androidOptions.map(optionField)}
            </>,
        }]} />
    </>
}
